"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _default = exports.default = _vue.default.component('input-text', {
  props: ['value', 'label', 'type', 'showPlainText', 'disabled'],
  data: function data() {
    return {
      plainTextEnabled: false,
      inputIdCache: ''
    };
  },
  computed: {
    inputId() {
      if (!this.inputIdCache) {
        // eslint-disable-next-line
        this.inputIdCache = 'inp_' + Math.floor(Math.random() * 1e17).toString(36);
      }
      return this.inputIdCache;
    },
    currentValue: {
      get: function getCurrentValue() {
        return this.value;
      },
      set: function setCurrentValue(newVal) {
        this.$emit('input', newVal);
      }
    }
  },
  methods: {
    updateValue(newValue) {
      this.$emit('input', newValue);
    },
    isEdgeBrowser() {
      return navigator.appVersion.indexOf('Edge') > -1;
    }
  }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["InputText"]
window._kiwi_exports.components.utils.InputText = exports.default ? exports.default : exports;
